import { actionCreatorFactory } from 'typescript-fsa';
import { GetResponseOrderParts } from '@app/react/const/type';

const actionCreator = actionCreatorFactory('fetch');

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface FetchFCListParam { }

export interface FetchFCListResult {
    items: GetResponseOrderParts;
}

export interface FetchFCListError {
    message: string;
}

export const fetchFamilyCrestList = actionCreator.async<
    FetchFCListParam,
    FetchFCListResult,
    FetchFCListError
>('familyCrest');
